import axios from "axios";
import {db_url} from "../url";

export default function Db_Visits (token) {
    const add_url = '/mobile/visits'

    const getVisits = (controller, search) => {
        return axios.get(db_url + add_url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getVisit = (controller, id) => {
        return axios.get(db_url + add_url , {
            signal: controller.signal,
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }


    return {
        getVisits,
        getVisit,
    }

}